// extracted by mini-css-extract-plugin
export var divider = "_p9-0";
export var systemMessage = "_p9-1";
export var systemMessageWrapper = "_p9-2";